const options = {
  5: "bg-fuchsia-50/5",
  10: "bg-fuchsia-50/10",
  25: "bg-fuchsia-50/25",
  50: "bg-fuchsia-50/50",
  75: "bg-fuchsia-50/75",
  90: "bg-fuchsia-50/90",
  100: "bg-fuchsia-50",
};

const from = {
  5: "from-fuchsia-50/5",
  10: "from-fuchsia-50/10",
  25: "from-fuchsia-50/25",
  50: "from-fuchsia-50/50",
  75: "from-fuchsia-50/75",
  90: "from-fuchsia-50/90",
  100: "from-fuchsia-50",
};

export default function getBackgroundFuchsia50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
